module.exports = __webpack_public_path__ + "static/media/Card1.d9d27303.png";